import React from 'react';
import {View} from 'react-native';

import Screen from '../../../../../shared/components/screen';

import {Props} from './model';
import {EvenOddList} from '../../../../../shared/components/evenOddList';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {useStyles} from '../../../../../shared/hooks/styles';

export default ({notifications, obtainingMethod}: Props) => {
  const styles = useStyles(({theme}) => ({
    container: {
      paddingBottom: theme.screen.bottomOffset,
    },
    item: {
      marginTop: 21,
      paddingHorizontal: 24,
      paddingBottom: 32,
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.container}>
          <View style={styles.item}>
            <EvenOddList testIDPrefix='notifations' list={notifications} title='Уведомления' />
          </View>
          <View style={styles.item}>
            <EvenOddList testIDPrefix='received-methods' list={obtainingMethod} title='Способ получения' />
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
